import { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Box,
  Button,
  IconButton,
  Chip,
  Dialog,
  DialogContent,
  CircularProgress,
} from '@mui/material';
import { Base64Image, GiftTypeEnum } from '../../../../utils/settings';
import OTPInput from '../../../Onboarding/Component/OtpInput';
import { CheckCircle, DownloadOutlined } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DetailsCard from './DetailsCard';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  downloadPodAction,
  sendOTPforGiftAction,
  UploadGiftImage,
  verifyOTPforGiftAction,
} from '../APIs/action';
import { GiftStatusEnum } from '../utils';
import ImageUpload from '../../../Components/ImageUpload';

const GiftDetailsCard = ({ data, type, onRefresh = () => {}, user_esi_id, selectedManufacturer }) => {
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otpText, setOtpText] = useState('');
  const [OTPVerfied, setOTPVerfied] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();
  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleViewImage = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenImage(true);
  };

  const handleClose = () => {
    setOpenImage(false);
    setSelectedImage('');
  };

  const {
    sender_details,
    receiver_details,
    gift_product_details,
    status,
    announced_date,
    voucher_code,
    id,
    show_history_button,
    show_influencer_history_button,
    gift_image,
    show_send_otp_button,
    show_pod_button ,
  } = data;
  const tabType = type;

  const statusButtonHandler = async () => {
    const { data, message, error } = await sendOTPforGiftAction(id, tabType, user_esi_id);
    if (!error) {
      toast.success(message);
      setOtpText(data?.sent_otp_text || '');
      setShowOtpInput(true);
    } else {
      toast.error(message);
    }
  };

  const verifyOTP = async () => {
    const payload = {
      gift_id: id,
      otp: otp,
      type: tabType,
      user_esi_id: user_esi_id,
    };
    const { message, error } = await verifyOTPforGiftAction(payload);
    if (!error) {
      toast.success(message);
      setShowOtpInput(false);
      onRefresh();
      return;
    } else {
      return toast.error(message);
    }
  };

  const getGiftStatusDetails = (status) =>
    Object.values(GiftStatusEnum).find((item) => item.status === status) || {};

  const [otp, setOtp] = useState('');
  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
  };

  const handleImageUpload = async (image_detail) => {
    // Prevent multiple uploads
    if (isUploading) {
      return;
    }

    setIsUploading(true);
    const { gift_image } = image_detail;
    const payload = {
      gift_id: id,
      type: tabType,
      gift_image,
      user_esi_id: user_esi_id,
    };

    try {
      const { message, error } = await UploadGiftImage(payload);

      if (!error) {
        toast.success(message);
        // Add a small delay to ensure the server has processed the image
        setTimeout(() => {
          onRefresh();
          setIsUploading(false);
        }, 500);
        return;
      } else {
        setIsUploading(false);
        return toast.error(message);
      }
    } catch (error) {
      setIsUploading(false);
      toast.error('Upload failed. Please try again.');
    }
  };
  const handleDownloadPodClick = async () => {
    if (isLoading) return;
    
    try {
      setIsLoading(true);
      const downloadPromise = downloadPodAction(
          id,
          tabType,
          user_esi_id,
          'POD_Certificate.pdf'
        );
      const minDelayPromise = new Promise(resolve => setTimeout(resolve, 1000));
      
      await Promise.all([downloadPromise, minDelayPromise]);
      
      const isInWebView = window.navigator.userAgent.includes('wv') || 
                          window.navigator.standalone || 
                          window.matchMedia('(display-mode: standalone)').matches;
      
      if (isInWebView) {
        console.log('Download initiated successfully');
      }
    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Grid
        container
        spacing={2}
        mt={1}
      >
        <Grid
          item
          xs={12}
          md={8}
        >
          {receiver_details && (
            <Grid
              item
              xs={12}
              md={12}
            >
              <Typography
                variant='h6'
                fontWeight='bold'
                sx={{ mb: 3 }}
                gutterBottom
              >
                Basic Details
              </Typography>
              <Card
                sx={{
                  borderRadius: '12px',
                  boxShadow:
                    '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                }}
              >
                <CardContent>
                  <DetailsCard details={receiver_details} />
                  <Grid
                    container
                    spacing={2}
                  >
                    <Grid
                      item
                      xs={6}
                      sm={6}
                    >
                      <Typography
                        variant='subtitle2'
                        fontWeight='bold'
                        sx={{
                          color: '#636363',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          mt: 2,
                        }}
                      >
                        Gift Status
                      </Typography>
                      <TextField
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                          '& .MuiInputBase-input': {
                            color:
                              getGiftStatusDetails(status)?.color || '#000',
                            fontWeight: 'bold',
                          },
                          '& .Mui-disabled': {
                            WebkitTextFillColor:
                              getGiftStatusDetails(status)?.color || '#000',
                          },
                        }}
                        fullWidth
                        margin='dense'
                        size='small'
                        value={getGiftStatusDetails(status)?.label || ''}
                        disabled
                      />
                    </Grid>
                    {status === GiftStatusEnum['GIFTED'].status && (
                        <>
                          {!gift_image && (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                            >
                              <Typography
                                variant='subtitle2'
                                fontWeight='bold'
                                sx={{
                                  color: '#636363',
                                  fontSize: '12px',
                                  textTransform: 'uppercase',
                                  mt: 2,
                                  mb: 1,
                                }}
                              >
                                Upload Image
                              </Typography>

                              <Box>
                                <ImageUpload
                                  key={`image-upload-${id}-${
                                    gift_image ? 'has-image' : 'no-image'
                                  }`}
                                  onImageUpload={handleImageUpload}
                                  label='Gifting Image'
                                  acceptedFileTypes={[
                                    'image/jpeg',
                                    'image/png',
                                    'image/jpg',
                                    'image/heic',
                                  ]}
                                  loading={isUploading}
                                />
                              </Box>
                            </Grid>
                          )}
                          {gift_image && (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                            >
                              <Typography
                                variant='subtitle2'
                                fontWeight='bold'
                                sx={{
                                  color: '#636363',
                                  fontSize: '12px',
                                  textTransform: 'uppercase',
                                  mt: 2,
                                  mb: 1,
                                }}
                              >
                                Uploaded Documents
                              </Typography>

                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  paddingX: '15px',
                                  borderRadius: '10px',
                                  border: '1px solid #c5c5c5',
                                }}
                              >
                                <Typography>Gift Image</Typography>
                                <IconButton
                                  onClick={() => handleViewImage(gift_image)}
                                  title='View Gift Image'
                                >
                                  <VisibilityIcon sx={{ color: 'orange' }} />
                                </IconButton>
                                <Dialog
                                  open={openImage}
                                  onClose={handleClose}
                                  maxWidth='md'
                                  fullWidth
                                  sx={{
                                    '& .MuiDialog-paper': {
                                      margin: { xs: '16px', sm: '32px' },
                                      maxHeight: { xs: '90vh', sm: '80vh' },
                                      borderRadius: '12px',
                                      overflow: 'hidden',
                                    },
                                  }}
                                >
                                  <DialogContent
                                    sx={{
                                      textAlign: 'center',
                                      padding: { xs: '16px', sm: '24px' },
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      minHeight: { xs: '300px', sm: '400px' },
                                      backgroundColor: '#f5f5f5',
                                    }}
                                  >
                                    <Base64Image
                                      base64String={selectedImage}
                                      altText={'Gift Image'}
                                      style={{
                                        width: '100%',
                                        height: 'auto',
                                        maxHeight: '70vh',
                                        maxWidth: '100%',
                                        objectFit: 'contain',
                                        borderRadius: '8px',
                                        boxShadow:
                                          '0 4px 12px rgba(0, 0, 0, 0.15)',
                                      }}
                                      onError={() => {
                                        console.error('Failed to display image');
                                        toast.error('Failed to load image. The image may be corrupted or in an unsupported format.');
                                      }}
                                      onLoad={() => {
                                        console.log('Image loaded successfully');
                                      }}
                                    />
                                    <Typography
                                      variant="caption"
                                      sx={{ mt: 2, color: '#666' }}
                                    >
                                      Gift Image Preview
                                    </Typography>
                                  </DialogContent>
                                </Dialog>
                              </Box>
                            </Grid>
                          )}
                        </>
                      )}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}
          {sender_details && (
            <Grid
              item
              xs={12}
              md={12}
            >
              <Typography
                variant='h6'
                fontWeight='bold'
                sx={{ my: 3 }}
                gutterBottom
              >
                Sender Details
              </Typography>
              <Card
                sx={{
                  borderRadius: '12px',
                  boxShadow:
                    '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                }}
              >
                <CardContent>
                  <DetailsCard
                    title='Sender Details'
                    details={sender_details}
                  />
                </CardContent>
              </Card>
            </Grid>
          )}
          {show_pod_button && (
            <Button
              variant="outlined"
              endIcon={!isLoading && <DownloadOutlined />}
              sx={{ 
                mt: 1,
                minHeight: '40px',
              }}
              fullWidth
              onClick={handleDownloadPodClick}
              disabled={isLoading}
            >
              {isLoading ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CircularProgress size={20} />
                  <span>Downloading...</span>
                </Box>
              ) : (
                'Download POD Certificate'
              )}
            </Button>
          )}
       
          {status !== GiftStatusEnum['GIFTED'].status &&
            show_send_otp_button &&
            status !== GiftStatusEnum['REDEEMED'].status &&
            !OTPVerfied && (
              <Grid
                item
                xs={12}
                md={12}
              >
           
            
                <Button
                  variant='outlined'
                  color='primary'
                  sx={{
                    mt: 1,
                  }}
                  fullWidth
                  onClick={statusButtonHandler}
                >
                  {status === GiftStatusEnum['ANNOUNCED'].status &&
                    gift_product_details.gift_type ===
                      GiftTypeEnum['WHITE_GOOD'] &&
                    'Product Received in Shop'}
                  {status === GiftStatusEnum['ANNOUNCED'].status &&
                    gift_product_details.gift_type ===
                      GiftTypeEnum['VOUCHER'] &&
                    'Redeem Gift Coupon'}
                  {status === GiftStatusEnum['IN_SHOP'].status &&
                    'Change Status to Gifted'}
                </Button>
                {showOtpInput && (
                  <Box>
                    <Typography
                      variant='subtitle2'
                      gutterBottom
                      fontSize={'.9rem'}
                      sx={{ mt: '2rem', mb: '1rem' }}
                    >
                      {otpText ||
                        'Please enter the OTP sent to your registered mobile number.'}
                    </Typography>
                    <OTPInput
                      isDark={false}
                      onOtpChange={handleOtpChange}
                    />
                    {/* <ResendOtp onResend={sendOTPHandler} /> */}
                    <Button
                      variant='outlined'
                      color='primary'
                      sx={{
                        mt: 2,
                      }}
                      fullWidth
                      onClick={() => verifyOTP(status)}
                    >
                      Verify OTP
                    </Button>
                  </Box>
                )}
              </Grid>
            )}
          {status === GiftStatusEnum['IN_SHOP'].status && OTPVerfied && (
            <Grid
              item
              xs={12}
              md={12}
            >
              <Card
                sx={{
                  borderRadius: '12px',
                  boxShadow:
                    '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                  padding: '10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 2,
                }}
              >
                <Typography
                  variant='h6'
                  fontWeight='bold'
                >
                  Otp Verification Done
                </Typography>
                <IconButton>
                  <CheckCircle sx={{ color: 'green' }} />
                </IconButton>
              </Card>
            </Grid>
          )}
          {status === GiftStatusEnum['REDEEMED'].status &&
            gift_product_details.gift_type === GiftTypeEnum['VOUCHER'] &&
            voucher_code && (
              <Grid
                item
                xs={12}
                md={12}
              >
                <Card
                  sx={{
                    borderRadius: '12px',
                    boxShadow:
                      '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                    padding: '10px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                    mt: 2,
                  }}
                >
                  <Typography
                    variant='h6'
                    fontWeight='bold'
                  >
                    Coupon Code
                  </Typography>
                  <Typography
                    variant='h6'
                    fontWeight='bold'
                  >
                    {voucher_code}
                  </Typography>
                </Card>
              </Grid>
            )}
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              md={6}
            >
              {show_history_button && (
                <Button
                  sx={{
                    my: 1,
                    background: '#fff',
                    borderRadius: '4px',
                    boxShadow:
                      '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                    color: '#5B5B5B',
                    fontWeight: 'bold',
                  }}
                  fullWidth
                  onClick={() =>
                    navigate('/benefits/rewards-history', {
                      state: {
                        company_id: receiver_details.company_id,
                        company_esi_id: receiver_details.company_esi_id,
                        type: 'SELF',
                        manufacturer_id: selectedManufacturer,
                        // sender_comapny_id: sender_details.company_id,
                        // sender_esi_id: sender_details.company_esi_id,
                      },
                    })
                  }
                >
                  View Previous Gift History
                </Button>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              {show_influencer_history_button && (
                <Button
                  sx={{
                    my: 1,
                    background: '#fff',
                    borderRadius: '4px',
                    boxShadow:
                      '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                    color: '#5B5B5B',
                    fontWeight: 'bold',
                  }}
                  fullWidth
                  onClick={() =>
                    navigate('/benefits/rewards-history', {
                      state: {
                        company_id: receiver_details.company_id,
                        company_esi_id: receiver_details.company_esi_id,
                        type: 'INFLUENCER',
                        manufacturer_id: selectedManufacturer
                      },
                    })
                  }
                >
                  View Influencers Rewards
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Typography
            variant='h6'
            fontWeight='bold'
            sx={{ mb: 2 }}
            gutterBottom
          >
            Product Details
          </Typography>
          <Card
            sx={{
              borderRadius: '12px',
              boxShadow:
                '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
              padding: '20px',
            }}
          >
            <Box>
              {gift_product_details && (
                <>
                  {gift_product_details?.gift_product_img ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Base64Image
                        base64String={gift_product_details?.gift_product_img}
                        altText={gift_product_details?.gift_product_name}
                        style={{ width: '300', marginBottom: '10px' }}
                      />
                    </Box>
                  ) : null}
                  {gift_product_details && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '30px',
                      }}
                    >
                      <Chip
                        label={gift_product_details?.gift_product_name}
                        sx={{
                          backgroundColor: '#b71d181a',
                          color: '#B71D18',
                          px: 2,
                          py: 0.5,
                          height: 'auto',
                          '& .MuiChip-label': {
                            display: 'block',
                            whiteSpace: 'normal',
                            paddingLeft: 2,
                            paddingRight: 2,
                          },
                        }}
                      />
                    </Box>
                  )}
                  <Grid
                    container
                    spacing={2}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography
                        variant='subtitle2'
                        fontWeight='bold'
                        sx={{
                          color: '#636363',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                        }}
                      >
                        Product Name
                      </Typography>
                      <TextField
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        }}
                        fullWidth
                        margin='dense'
                        size='small'
                        value={gift_product_details?.gift_product_name}
                        disabled
                      />
                    </Grid>
                    {gift_product_details?.gift_product_brand && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                      >
                        <Typography
                          variant='subtitle2'
                          fontWeight='bold'
                          sx={{
                            color: '#636363',
                            fontSize: '12px',
                            textTransform: 'uppercase',
                          }}
                        >
                          Product Brand
                        </Typography>
                        <TextField
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '10px',
                            },
                          }}
                          fullWidth
                          margin='dense'
                          size='small'
                          value={gift_product_details?.gift_product_brand}
                          disabled
                        />
                      </Grid>
                    )}
                    <Grid
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography
                        variant='subtitle2'
                        fontWeight='bold'
                        sx={{
                          color: '#636363',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                        }}
                      >
                        Annouced Date
                      </Typography>
                      <TextField
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        }}
                        fullWidth
                        margin='dense'
                        size='small'
                        value={announced_date}
                        disabled
                      />
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default GiftDetailsCard;
